// Plugins
import GLightbox from '../../../../assets/vendor/glightbox/glightbox.min.js';

// Local
export const initUiKit = ($wrapper) => {
    $wrapper.querySelectorAll('[data-header]').forEach(async ($item) => {
        const Header = await import('./partials/header');
        (new Header.default($item));
    });
    $wrapper.querySelectorAll('[data-animate]').forEach(async($item) => {
        const Animate = await import('./partials/animate');
        (new Animate.default($item));
    });
    $wrapper.querySelectorAll('[data-form]').forEach(async($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
    $wrapper.querySelectorAll('[data-alert]').forEach(async($el) => {
        const Alert = await import('./partials/alert');
        (new Alert.default($el));
    });
    $wrapper.querySelectorAll('[data-collapsible]').forEach(async($el) => {
        const Collapsible = await import('./partials/collapsible');
        (new Collapsible.default($el));
    });
    $wrapper.querySelectorAll('[data-modal]').forEach(async($el) => {
        const Modal = await import('./partials/modal');
        (new Modal.default($el));
    });
    $wrapper.querySelectorAll('[data-tabs]').forEach(async($el) => {
        const Tabs = await import('./partials/tabs');
        (new Tabs.default($el));
    });
    $wrapper.querySelectorAll('[data-dropdown]').forEach(async($el) => {
        const Dropdown = await import('./partials/dropdown');
        (new Dropdown.default($el));
    });
    $wrapper.querySelectorAll('[data-password]').forEach(async($el) => {
        const PasswordControl = await import('./partials/password-control');
        (new PasswordControl.default($el));
    });
    $wrapper.querySelectorAll('[data-autocomplete]').forEach(async($el) => {
        const Autocomplete = await import('./partials/autocomplete');
        (new Autocomplete.default($el));
    });
    $wrapper.querySelectorAll('[data-image-button]').forEach(async($el) => {
        const ImageButton = await import('./partials/image-button');
        (new ImageButton.default($el));
    });
    $wrapper.querySelectorAll('[data-chunked-upload]').forEach(async($el) => {
        const ChunkedUpload = await import('./partials/chunked-upload');
        (new ChunkedUpload.default($el));
    });
    $wrapper.querySelectorAll('[data-loader]').forEach(async($el) => {
        const Loader = await import('./partials/loader');
        (new Loader.default($el));
    });
    $wrapper.querySelectorAll('[data-mask]').forEach(async ($el) => {
        const IMask = await import('../../../../assets/vendor/imask');
        new IMask.default($el, {mask: $el.dataset.mask});
    });
    $wrapper.querySelectorAll('[data-date-mask]').forEach(async ($el) => {
        const DateMask = await import('../../../../assets/js/shared/date-mask');
        (new DateMask.default($el));
    });
    $wrapper.querySelectorAll('[data-select]').forEach(async($el) => {
        const Choices = await import('./../../../../assets/vendor/choices.js/public/assets/scripts/choices');
        (new Choices.default($el, {
            placeholder: $el.dataset.selectPlaceholder !== undefined,
            placeholderValue: $el.dataset.selectPlaceholder,
            searchEnabled: $el.querySelectorAll('option').length > 8,
            noResultsText: translations.noResultsText,
            noChoicesText: translations.noChoicesText,
            itemSelectText: '',
            uniqueItemText: translations.uniqueItemText,
            customAddItemText: translations.customAddItemText,
            removeItemButton: false,
        }));
    });

    GLightbox({
        selector: '[data-glightbox]',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });

    // Helper method to check if ui-kit is already initialized
    $wrapper.uiKitInitialized = true;
}

window.initUiKit = initUiKit;

(function() {
    window.initUiKit(document);
})();